import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { ColumnContainer } from 'utils/columnsStyle';
import { productSelected, editProductMode } from 'redux/actions/productsCatalog/productsCatalogActions'
import { useDispatch } from 'react-redux';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const columns = [
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Consecutivo</span> ),
    accessor: "consecutive",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.consecutive) 
      ? String(row.consecutive).includes(filter.value)
      : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Nombre</span> ),
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) =>
      row.name
        ? row.name.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>SAT producto</span> ),
    accessor: "satProductCode",
    filterable: true,
    filterMethod: (filter, row) =>
      row.satProductCode
      ? row.satProductCode.includes(filter.value)
      : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>U. de Medida</span> ),
    accessor: "measureUnit",
    filterable: true,
    filterMethod: (filter, row) =>
      row.measureUnit
        ? row.measureUnit.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>SAT unidad</span> ),
    accessor: "satUnitCode",
    filterable: true,
    filterMethod: (filter, row) =>
      row.satUnitCode
        ? row.satUnitCode.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Tipo</span> ),
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) =>
      row.type
        ? row.type.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Capacidad</span> ),
    accessor: "capacity",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.capacity) 
      ? String(row.capacity).includes(filter.value)
      : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Visualización</span> ),
    accessor: "display",
    filterable: true,
    filterMethod: (filter, row) =>
      row.display
      ? row.display.includes(filter.value)
      : "",
  },
  {
    Header: () => ( <span style={{ fontSize: '.86rem' }}>Acciones</span> ),
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const openEdit = () => {
        dispatch(editProductMode())
        original.modal()
        dispatch(productSelected(original.id))
      }
      // const openEliminate = () => {
      //   dispatch(deleteProductMode())
      //   original.modal()
      //   dispatch(productSelected(original.id))
      // }
      //const { addProduct } = useSelector(state => state.productsCatalog)
      return (
        <ColumnContainer>
          <EditIcon style={style} onClick={openEdit}/>
          {/* {
            addProduct && <DeleteIcon style={{ ...style,  color: '#e83737'}} onClick={openEliminate}/>
          } */}
        </ColumnContainer>
      )
    },
  },
];